<template>

  <div
    class="einvoice-goods-table-wrapper"
    :class="{
      'einvoice-goods-table-wrapper--scrollable': isScrollable,
      'einvoice-goods-table-wrapper--sticky-head': stickyHead,
    }"
    :style="wrapperStyle"
  >
     <b-table-simple
      responsive
      small
      class="einvoice-goods-table mb-0"
      > <b-thead
        > <b-tr
          > <b-th class="text-center col-stt">Stt</b-th> <b-th class="col-name"
            >Tên hàng hóa, dịch vụ</b-th
          > <b-th class="text-center col-unit">Đvt</b-th> <b-th class="text-right col-qty"
            >Số lượng</b-th
          > <b-th class="text-right col-price">Đơn giá</b-th> <b-th class="text-right col-discount"
            >Chiết khấu</b-th
          > <b-th class="text-center col-rate">Thuế suất</b-th> <b-th class="text-right col-total"
            >Thành tiền chưa thuế GTGT</b-th
          > </b-tr
        > </b-thead
      > <b-tbody v-if="items.length"
        > <b-tr
          v-for="(item, index) in items"
          :key="resolveItemKey(item, index)"
          > <b-td class="text-center col-number">{{ resolveLineNumber(item, index) }}</b-td
          > <b-td class="col-name"
            >
            <div class="product-cell">
               <ProductImage
                v-if="showProductImage"
                :src="item.imageUrl"
                :alt="item.itemName || '---'"
              />
              <div class="product-copy">

                <div
                  class="product-name"
                  :title="item.itemName || '---'"
                >
                   <i
                    v-if="item.isBonus"
                    class="fas fa-gift product-icon gift"
                    title="Quà tặng"
                  ></i
                  > {{ item.itemName || '---' }}
                </div>

                <div
                  v-if="showItemCode && item.itemCode"
                  class="product-code"
                >
                   {{ item.itemCode }}
                </div>

              </div>

            </div>
             </b-td
          > <b-td class="text-center">{{ resolveLineUnitOfMeasureText(item) }}</b-td
          > <b-td class="text-right col-number">{{ resolveLineQuantityText(item) }}</b-td
          > <b-td class="text-right col-number">{{
            formatCurrency(resolveLineUnitPriceValue(item))
          }}</b-td
          > <b-td class="text-right col-number">{{
            formatCurrency(resolveLineDiscountValue(item))
          }}</b-td
          > <b-td class="text-center tax-rate-text">{{ formatTaxRate(item.taxRate) }}</b-td
          > <b-td class="text-right col-number font-weight-bold"
            > {{ formatCurrency(resolveLineTotalBeforeTaxValue(item)) }} </b-td
          > </b-tr
        > </b-tbody
      > <b-tbody v-else
        > <b-tr
          > <b-td
            colspan="8"
            class="text-center text-muted py-4"
            > {{ emptyText }} </b-td
          > </b-tr
        > </b-tbody
      > </b-table-simple
    >
  </div>

</template>

<script>
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import {
    isSyntheticBillDiscountLine,
    resolveLineDiscountBeforeTax,
    resolveLineNetAfterDiscount,
    resolveLineUnitNetBeforeDiscount,
  } from '@/view/pages/einvoice/utils/lineMoneyBreakdown.utils'

  export default {
    name: 'EInvoiceGoodsTable',

    components: {
      ProductImage,
    },

    props: {
      items: {
        type: Array,
        default: () => [],
      },
      maxHeight: {
        type: [Number, String],
        default: null,
      },
      emptyText: {
        type: String,
        default: 'Không có dữ liệu',
      },
      showProductImage: {
        type: Boolean,
        default: false,
      },
      showItemCode: {
        type: Boolean,
        default: false,
      },
      stickyHead: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      isScrollable() {
        return this.maxHeight !== null && this.maxHeight !== undefined && this.maxHeight !== ''
      },

      wrapperStyle() {
        if (!this.isScrollable) {
          return {}
        }

        return {
          maxHeight: typeof this.maxHeight === 'number' ? `${this.maxHeight}px` : this.maxHeight,
        }
      },
    },

    methods: {
      formatCurrency(value) {
        if (value == null) return '0'
        return new Intl.NumberFormat('vi-VN').format(Number(value) || 0)
      },

      formatQuantity(value) {
        if (value == null || value === '') return '0'
        return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 3 }).format(
          Number(value) || 0,
        )
      },

      resolveLineNumber(item = {}, index = 0) {
        return item.lineNumber || index + 1
      },

      resolveItemKey(item = {}, index = 0) {
        return [item.lineNumber, item.itemCode, item.productId, item.itemName, index]
          .filter((part) => part !== null && part !== undefined && part !== '')
          .join(':')
      },

      resolveLineUnitPriceValue(item = {}) {
        return resolveLineUnitNetBeforeDiscount(item)
      },

      resolveLineDiscountValue(item = {}) {
        if (isSyntheticBillDiscountLine(item)) {
          return ''
        }

        return resolveLineDiscountBeforeTax(item)
      },

      resolveLineTotalBeforeTaxValue(item = {}) {
        return resolveLineNetAfterDiscount(item)
      },

      resolveLineUnitOfMeasureText(item = {}) {
        if (isSyntheticBillDiscountLine(item)) {
          return ''
        }

        return item.unitOfMeasure || '---'
      },

      resolveLineQuantityText(item = {}) {
        if (isSyntheticBillDiscountLine(item)) {
          return ''
        }

        return this.formatQuantity(item.quantity)
      },

      formatTaxRate(taxRate) {
        if (taxRate === -1) return 'KCT'
        if (taxRate === -2) return 'KKK'
        if (taxRate === -9) return 'XK'
        return `${Number(taxRate) || 0}%`
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-goods-table-wrapper {
    background: #fff;
  }

  .einvoice-goods-table-wrapper--scrollable {
    overflow: auto;
  }

  .einvoice-goods-table {
    border-collapse: collapse;
    background: #fff;
    table-layout: fixed;

    thead th {
      padding: 0.78rem 0.6rem;
      border: 1px solid #d8e0e8;
      background: #f4f7fa;
      color: #5a697b;
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.05em;
      line-height: 1.3;
      text-transform: uppercase;
      vertical-align: middle;
    }

    td {
      padding: 0.9rem 0.62rem;
      border: 1px solid #e2e8ee;
      background: #fff;
      vertical-align: middle;
      line-height: 1.42;
      color: #2b3542;
    }

    tbody tr:nth-child(even) td {
      background: #fcfdff;
    }
  }

  .einvoice-goods-table-wrapper--scrollable.einvoice-goods-table-wrapper--sticky-head
    .einvoice-goods-table
    thead
    th {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .col-stt {
    width: 54px;
  }

  .col-name {
    min-width: 320px;
  }

  .col-unit {
    width: 84px;
  }

  .col-qty {
    width: 108px;
  }

  .col-price,
  .col-discount,
  .col-total {
    width: 148px;
  }

  .col-rate {
    width: 96px;
  }

  .col-number {
    font-variant-numeric: tabular-nums;
    color: #314254;
  }

  .product-cell {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    min-width: 0;
  }

  .product-copy {
    min-width: 0;
    flex: 1;
  }

  .product-name {
    color: #1d2936;
    font-weight: 600;
    line-height: 1.5;
    word-break: break-word;
  }

  .product-icon.gift {
    color: #2e7d32;
  }

  .product-code {
    margin-top: 0.15rem;
    color: #6c757d;
    font-size: 0.73rem;
    line-height: 1.2;
  }

  .tax-rate-text {
    font-weight: 600;
    color: #536273;
    letter-spacing: 0.01em;
  }

  @media (max-width: 991.98px) {
    .einvoice-goods-table {
      thead th {
        padding: 0.62rem 0.5rem;
      }

      td {
        padding: 0.68rem 0.5rem;
      }
    }

    .col-name {
      min-width: 280px;
    }
  }
</style>

